import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import {initReactI18next} from 'react-i18next';
import {preloadAndSetDayJsLocale, LANGUAGE_CODES} from '@guestapp/core';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(
    {
      fallbackLng: LANGUAGE_CODES.en,
      detection: {
        order: ['querystring', 'localStorage', 'navigator'],
      },
      load: 'languageOnly',
      interpolation: {
        escapeValue: false,
      },
      returnNull: false,
    },
    () => {
      preloadAndSetDayJsLocale(i18n.language);
    },
  );

export {i18n};
